import firebase from 'firebase/compat/app'; //v9
import 'firebase/compat/firestore'; //v9
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import 'firebase/compat/auth';
import 'firebase/database';
import 'firebase/storage';
const firebaseConfig = {
  apiKey: "AIzaSyBLyhlg-aVRL-dD9EPIRCeo_dgwkmn_kHY",
  authDomain: "costan-4b8e5.firebaseapp.com",
  projectId: "costan-4b8e5",
  storageBucket: "costan-4b8e5.appspot.com",
  messagingSenderId: "552399994125",
  appId: "1:552399994125:web:538d129a6393293d3b8444",
  measurementId: "G-EB1LEQ8NCS"
};

//export const firebaseAnalytics = firebase.analytics();
//export default firebase ;
firebase.initializeApp(firebaseConfig);
 export default firebase ;
//   var firebase  = initializeApp(firebaseConfig);


// export default firebase;
